import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { id: "error-page" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("div", { class: "content" }, [
      _createElementVNode("h2", {
        class: "header",
        "data-text": "403",
        style: {"background":"transparent"}
      }, " 403 "),
      _createElementVNode("h4", { "data-text": "Forbidden! Access Denied" }, " Forbidden! Access Denied "),
      _createElementVNode("p", null, " Please contract to the adminstrator ")
    ], -1)
  ]))]))
}